(function () {
  "use strict";

  // Automatic browser errors are extremely noisy on Shopify storefronts because
  // pixels, apps, browser extensions, and injected scripts all execute alongside
  // the theme. Only a small, source-attributed sample should leave the browser.
  var AUTO_ERROR_SAMPLE_RATE = 0.01;
  var MAX_AUTO_ERRORS_PER_PAGE = 1;
  var MANUAL_CAPTURE_TAG = "storefront-critical-flow";
  var automaticErrorsSent = 0;
  var pendingManualCaptures = [];

  var IGNORED_MESSAGES = [
    /^(?:Script error\.?|ResizeObserver loop)/i,
    /^(?:Load failed|Failed to fetch|Network Error)$/i,
    /Non-Error promise rejection captured with value: (?:undefined|null)$/i,
  ];

  function getExceptionMessage(event) {
    var values = event && event.exception && event.exception.values;
    var exception = values && values[values.length - 1];
    return (exception && exception.value) || event.message || "";
  }

  function getFrames(event) {
    var frames = [];
    var values = event && event.exception && event.exception.values;

    if (values) {
      values.forEach(function (exception) {
        var exceptionFrames = exception && exception.stacktrace && exception.stacktrace.frames;
        if (exceptionFrames) frames = frames.concat(exceptionFrames);
      });
    }

    if (event && event.stacktrace && event.stacktrace.frames) {
      frames = frames.concat(event.stacktrace.frames);
    }

    return frames;
  }

  function isOwnedThemeAsset(filename) {
    if (!filename || /custom-sentry\.js(?:[?#]|$)/i.test(filename)) return false;

    // Shopify serves theme assets either through the storefront /cdn/shop path
    // or its s/files CDN path. Pixel/app/extension scripts do not use this path.
    return /(?:\/cdn\/shop|\/s\/files\/[^?#]+)\/t\/\d+\/assets\/[^/?#]+\.js(?:[?#]|$)/i.test(filename);
  }

  function hasOwnedThemeFrame(event) {
    return getFrames(event).some(function (frame) {
      return isOwnedThemeAsset(frame && (frame.filename || frame.abs_path));
    });
  }

  function isManualCapture(event) {
    return event && event.tags && event.tags.monitoring_source === MANUAL_CAPTURE_TAG;
  }

  function shouldIgnoreMessage(event) {
    var message = getExceptionMessage(event);
    return IGNORED_MESSAGES.some(function (pattern) {
      return pattern.test(message);
    });
  }

  function beforeSend(event) {
    // Errors explicitly reported through captureStorefrontError represent a
    // business-critical operation and should never be randomly sampled out.
    if (isManualCapture(event)) return event;

    if (shouldIgnoreMessage(event) || !hasOwnedThemeFrame(event)) return null;
    if (automaticErrorsSent >= MAX_AUTO_ERRORS_PER_PAGE) return null;
    if (Math.random() >= AUTO_ERROR_SAMPLE_RATE) return null;

    automaticErrorsSent += 1;
    event.tags = event.tags || {};
    event.tags.monitoring_source = "automatic-owned-theme";
    return event;
  }

  function sendManualCapture(error, context) {
    context = context || {};
    var tags = Object.assign({}, context.tags, {
      monitoring_source: MANUAL_CAPTURE_TAG,
      component: context.component || "unknown",
      operation: context.operation || "unknown",
    });

    window.Sentry.captureException(error, {
      tags: tags,
      extra: context.extra,
    });
  }

  // Use this for failures in deliberately selected purchase-critical flows.
  // Calls made before the deferred SDK load are queued instead of being lost.
  window.captureStorefrontError = function (error, context) {
    if (!error) return;

    if (window.Sentry && typeof window.Sentry.captureException === "function") {
      sendManualCapture(error, context);
      return;
    }

    if (pendingManualCaptures.length < 10) {
      pendingManualCaptures.push([error, context]);
    }
  };

  window.sentryOnLoad = function () {
    window.Sentry.init({
      environment: "production",
      sendDefaultPii: false,
      maxBreadcrumbs: 30,
      beforeSend: beforeSend,
    });

    pendingManualCaptures.forEach(function (capture) {
      sendManualCapture(capture[0], capture[1]);
    });
    pendingManualCaptures = [];
  };

  // Start fetching Sentry's small loader immediately. Dynamically inserted
  // scripts cannot fully block the parser, so this is slightly weaker than a
  // separate first-party <script> tag, but keeps all integration code here.
  function loadSentryLoader() {
    if (document.querySelector("script[data-kess-sentry-loader]")) return;

    var loader = document.createElement("script");
    loader.src = "https://js-de.sentry-cdn.com/19b691e31dd16957782b2623fd28d8cc.min.js";
    loader.async = false;
    loader.crossOrigin = "anonymous";
    loader.setAttribute("data-kess-sentry-loader", "");
    document.head.appendChild(loader);
  }

  loadSentryLoader();
})();
